import { Grid } from '@mui/system';
import { WIDTH_CONSTANTS } from '@theme/widthConstants';

export const WidthContainer = ({ children }: { children: React.ReactNode }) => (
  <Grid
    id-testid='width-container'
    container
    sx={{
      width: '100%',
      maxWidth: WIDTH_CONSTANTS.MAX_PAGE_WIDTH_CONSTANT,
      marginX: 'auto',
      justifyContent: 'center',
      padding: 0,
    }}
  >
    {children}
  </Grid>
);
